import React, { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

import { useLanguage } from "../../../i18n/useLanguage";
import { AccessoryPartItem } from "../../../queries/useSearchAccessoriesByVehicle";
import { KeyValue } from "../../../ui/KeyValue/KeyValue";
import { Placeholder } from "../../../ui/Placeholder";
import { Details } from "../Common/Details";

type AccessorySpecProps = {
  part: AccessoryPartItem | null;
};

export const AccessorySpec: FunctionComponent<AccessorySpecProps> = ({
  part,
}) => {
  const { t } = useTranslation();
  const [language] = useLanguage();
  return (
    <Details className="text-xs grid gap-2 md:grid-cols-2">
      <KeyValue className="items-start">
        <>{t("searchResults.partNumber")}:</>
        <Placeholder className="w-8" loading={!part}>
          {part?.partDetails.primaryPart.accessoryPartNumber}
        </Placeholder>
      </KeyValue>
      <KeyValue className="items-start">
        <>{t("searchResults.restrictions")}:</>
        <Placeholder className="w-8" loading={!part}>
          {part?.partDetails.primaryPart.accessoryRestrictions[language] ||
            "N/A"}
        </Placeholder>
      </KeyValue>
      <KeyValue className="items-start">
        <>{t("searchResults.requiresInstallation")}:</>
        <Placeholder className="w-8" loading={!part}>
          {part?.partDetails.primaryPart.accessoryRequiresInstallation === "0"
            ? t("searchResults.no")
            : t("searchResults.yes")}
        </Placeholder>
      </KeyValue>
      <KeyValue className="items-start">
        <>{t("searchResults.categories")}:</>
        <Placeholder className="w-8" loading={!part}>
          {part?.partDetails.primaryPart.accessoryCategories
            .map((cat) => {
              const [item] = Object.values(cat);
              return item[language];
            })
            .join(", ")}
        </Placeholder>
      </KeyValue>
    </Details>
  );
};
